/** Shared, spoiler-free sharing. Never pass answers, room tokens or personal data. */
export function socialLinks(text, url) {
  return {
    X: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`,
    WhatsApp: `https://wa.me/?text=${encodeURIComponent(text)}`,
    Facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    Email: `mailto:?subject=My%20JoyBoxLabs%20result&body=${encodeURIComponent(text)}`,
  };
}
export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch {}
  const area = document.createElement('textarea');
  area.value = text;
  area.style.cssText = 'position:fixed;left:-9999px;top:0';
  document.body.append(area);
  area.select();
  let copied = false;
  try { copied = document.execCommand('copy'); } catch {}
  area.remove();
  return copied;
}
export function showSharePanel(text) {
  document.getElementById('joybox-share')?.close();
  const previous = document.activeElement;
  const dialog = document.createElement('dialog');
  dialog.id = 'joybox-share';
  dialog.className = 'jb-share';
  dialog.setAttribute('aria-labelledby', 'jb-share-title');
  dialog.setAttribute('aria-modal', 'true');
  dialog.innerHTML = `<h2 id="jb-share-title">A little friendly competition.</h2><p>Your result, without the spoilers.</p><label for="jb-share-text">Your share card</label><textarea id="jb-share-text" readonly rows="7"></textarea><div class="jb-share-actions"></div><nav aria-label="Share on social media"></nav><p class="jb-share-status" role="status" aria-live="polite"></p><button class="jb-close" type="button">Done</button>`;
  const area = dialog.querySelector('textarea');
  area.value = text;
  const status = dialog.querySelector('[role=status]');
  const actions = dialog.querySelector('.jb-share-actions');
  const add = (label, fn) => { const b = document.createElement('button'); b.type = 'button'; b.textContent = label; b.onclick = fn; actions.append(b); };
  add('Copy result', async () => {
    if (await copyText(text)) status.textContent = 'Copied. Ready to paste into your chat or post.';
    else { area.focus(); area.select(); status.textContent = 'Select and copy the result above using your device’s copy command.'; }
  });
  add('Save image', () => {
    try { downloadScorecard(text); status.textContent = 'Image saved. Add it to your story or post.'; }
    catch { status.textContent = 'Image saving is unavailable. Copy the text above instead.'; }
  });
  if (navigator.share) add('More apps', async () => {
    try { await navigator.share({ title: 'JoyBoxLabs', text }); status.textContent = 'Shared!'; }
    catch (e) { if (e.name !== 'AbortError') status.textContent = 'Choose a link below or copy your result.'; }
  });
  const url = text.match(/https:\/\/[^\s]+/g)?.at(-1) || 'https://joyboxlabs.com/';
  for (const [name, href] of Object.entries(socialLinks(text, url))) {
    const a = document.createElement('a'); a.textContent = name; a.href = href; a.target = '_blank'; a.rel = 'noopener noreferrer'; dialog.querySelector('nav').append(a);
  }
  dialog.querySelector('.jb-close').onclick = () => dialog.close();
  dialog.addEventListener('close', () => { dialog.remove(); document.dispatchEvent(new window.Event('joybox:modal-change')); if (previous?.isConnected) previous.focus(); }, { once: true });
  document.body.append(dialog);
  dialog.showModal();
  document.dispatchEvent(new window.Event('joybox:modal-change'));
  return dialog;
}
export async function shareResult(text) {
  if (navigator.share) {
    try { await navigator.share({ title: 'JoyBoxLabs', text }); return 'shared'; }
    catch (error) { if (error.name === 'AbortError') return 'cancelled'; }
  }
  showSharePanel(text);
  return 'panel';
}
export function downloadScorecard(text) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas unavailable');
  ctx.font = '30px system-ui, sans-serif';
  const lines = [];
  for (const raw of text.split('\n')) {
    let line = '';
    for (const char of Array.from(raw)) {
      if (ctx.measureText(line + char).width > 880) { lines.push(line); line = ''; }
      line += char;
    }
    lines.push(line);
  }
  canvas.height = Math.max(720, 340 + lines.length * 48);
  ctx.fillStyle = '#f7f5f0'; ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#6a4dff'; ctx.fillRect(64, 64, 12, 62);
  ctx.fillStyle = '#1a1b1f'; ctx.font = 'bold 44px system-ui, sans-serif'; ctx.fillText('JoyBoxLabs', 102, 110);
  ctx.font = '30px system-ui, sans-serif';
  lines.forEach((line, i) => ctx.fillText(line, 80, 208 + i * 48));
  ctx.fillStyle = '#565b66'; ctx.font = '26px system-ui, sans-serif'; ctx.fillText('A little play. Every day.', 80, canvas.height - 64);
  const a = document.createElement('a'); a.download = 'joyboxlabs-result.png'; a.href = canvas.toDataURL('image/png'); a.click();
}
